module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo3-e20334dc2e84633e93182600d3c2dad6.jpg";